import { makeAutoObservable } from "mobx";
var BotsStore = /** @class */ (function () {
    function BotsStore() {
        this._bots = null;
        makeAutoObservable(this);
    }
    BotsStore.prototype.setBots = function (bots) {
        this._bots = bots;
    };
    Object.defineProperty(BotsStore.prototype, "bots", {
        get: function () {
            return this._bots;
        },
        enumerable: false,
        configurable: true
    });
    return BotsStore;
}());
export default BotsStore;
